"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function phase(fn) {
  var extensions = {
    before: [],
    after: [],
    error: []
  };
  return {
    call: function call(services) {
      return function (next) {
        return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _len,
              args,
              _key,
              nextWrapper,
              action,
              errorHandlers,
              _args = arguments;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = _args[_key];
                  }

                  nextWrapper = function nextWrapper() {
                    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                      args[_key2] = arguments[_key2];
                    }

                    extensions.after.forEach(function (extension) {
                      return extension.apply(void 0, args);
                    }); // TODO: can extensions can be async?

                    return next.apply(void 0, args);
                  };

                  _context.prev = 2;
                  action = fn(services)(nextWrapper);
                  extensions.before.forEach(function (extension) {
                    return extension.apply(void 0, args);
                  }); // TODO: can extensions can be async?

                  _context.next = 7;
                  return action.apply(void 0, args);

                case 7:
                  _context.next = 17;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](2);
                  errorHandlers = extensions.error;

                  if (!(errorHandlers.length === 0)) {
                    _context.next = 16;
                    break;
                  }

                  throw _context.t0;

                case 16:
                  errorHandlers.forEach(function (extension) {
                    return extension.apply(void 0, [_context.t0].concat(args));
                  }); // TODO: can extensions can be async?

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 9]]);
        }));
      };
    },
    extend: function extend() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        enter: null,
        exit: null,
        error: null
      },
          enter = _ref2.enter,
          exit = _ref2.exit,
          error = _ref2.error;

      if (enter) {
        extensions.before.push(enter);
      }

      if (exit) {
        extensions.after.push(exit);
      }

      if (error) {
        extensions.error.push(error);
      }
    }
  };
}

var _default = phase;
exports.default = _default;